import { AddMetaPluginModal } from "./AddMetaPluginModal";

export default AddMetaPluginModal;
